import apiClient from '@/services/axios'

export async function get() {
    var response = await apiClient.get(`/Idam/User/Permissions?useCache=true`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to get IDAM permissions for user')
}
